import { useEffect, useRef } from '@redneckz/uni-jsx/lib/hooks';
export function useResizeObserver(callback, deps) {
    const ref = useRef(null);
    useEffect(() => {
        const element = ref?.current;
        if (!element) {
            return undefined;
        }
        const observer = new ResizeObserver((entries) => {
            callback(element, entries[0]);
        });
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [callback, ...deps]);
    return ref;
}
//# sourceMappingURL=useResizeObserver.js.map